'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('../_tslib-bcbe0269.js');

var core = require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);

var IconGithub = React__default.forwardRef(function (_a, ref) {
  var _b = _a.weight,
      weight = _b === void 0 ? "normal" : _b,
      props = _tslib.__rest(_a, ["weight"]);

  return core.jsx("svg", _tslib.__assign({
    viewBox: "0 0 26 26",
    ref: ref,
    css: core.css(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 26px;\n      "], ["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 26px;\n      "])))
  }, props), core.jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, core.jsx("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.425 22.985V20.95c0-1.081-.371-1.876-1.112-2.385.465-.045.891-.107 1.279-.188a9.967 9.967 0 0 0 1.233-.348 6.039 6.039 0 0 0 1.166-.543c.344-.21.674-.482.991-.817.317-.335.583-.715.797-1.139.215-.424.384-.933.509-1.527a9.543 9.543 0 0 0 .188-1.963c0-1.384-.451-2.563-1.353-3.537.411-1.072.366-2.237-.134-3.497l-.335-.04c-.232-.027-.65.071-1.253.295-.603.224-1.279.589-2.03 1.098a12.317 12.317 0 0 0-3.309-.442c-1.152 0-2.251.147-3.296.442a11.41 11.41 0 0 0-1.346-.797 6.948 6.948 0 0 0-1.018-.429 3.503 3.503 0 0 0-1.132-.154.844.844 0 0 0-.134.027c-.5 1.268-.545 2.434-.134 3.497-.902.973-1.353 2.152-1.353 3.537 0 .715.063 1.369.188 1.963.125.594.295 1.103.509 1.527.214.424.48.804.797 1.139.317.335.647.607.991.817.344.21.732.391 1.166.543a9.54 9.54 0 0 0 1.233.348c.389.08.815.143 1.279.188-.732.5-1.098 1.295-1.098 2.385v2.075C10.5 24 14 24 15.425 22.985z"
  }), core.jsx("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "currentColor",
    strokeWidth: weight === "normal" ? 1.5 : 1
  })));
});
var templateObject_1;
exports.IconGithub = IconGithub;